<template>
<div class="goodsList">
    <bBGoodsList :hostroletype="hostroletype"></bBGoodsList>
</div>
</template>

<script>
import BBGoodsList from 'views/brandBusiness/systemSetting/goodsBack/GoodsList.vue'
export default {
    name: 'goodsList',
    props: ['hostroletype'],
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {
        BBGoodsList
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.goodsList {
}
</style>
